import CompanyLanguagesPageView from "./CompanyLanguagesPageView";

function CompanyLanguagesPage() {
  return <CompanyLanguagesPageView />;
}

export default CompanyLanguagesPage;
